export const getVisitsData = (store) => store.visits.data;

export const getSelectedVisit = (store) => store.visits.selectedVisit;
export const getSelectedDate = (store) => store.visits.selectedDate;

export const getVisitdate = (store) => store.visits.visitDate;
export const getVisitRange = (store) => store.visits.visitRange;
export const getDayCount = (store) => store.visits.dayCount;
